
import { Backdrop, BackdropProps } from "@mui/material";
import React from "react";

const BackdropWrapper: React.FC<BackdropProps> = ({ ...props }) => <Backdrop {...props} />;

export default BackdropWrapper;
